import { render } from "./addcontent2.vue?vue&type=template&id=761ca72e"
import script from "./addcontent2.vue?vue&type=script&lang=js"
export * from "./addcontent2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__